import { useMemo } from 'react'
import { SetURLSearchParams, useSearchParams } from 'react-router-dom'

export type UseUrlQueryOutput = {
  urlQuery: { name: string; id: string } | null
  setUrlQuery: SetURLSearchParams
}

export const useUrlQuery = (): UseUrlQueryOutput => {
  const [searchParams, setSearchParams] = useSearchParams()
  const query = searchParams.get('query')

  const queryArray = useMemo(() => query?.split(/-(.+)/), [query])
  const urlQuery = useMemo(
    () => (queryArray ? { name: queryArray[0], id: queryArray[1] } : null),
    [queryArray],
  )

  return { urlQuery, setUrlQuery: setSearchParams }
}
